<template>
  <Card class="w-full mb-30" centerContent>
    <CardHeader
      :title="$t('health_actions.scheduler.title')"
      icon="CalendarFavorite"
      accentColor="sky"
    >
    </CardHeader>
    <div class="p-20">
      <div>
        <SchedulerHeadsetIconSection />
        <div class="px-80 mt-20">
          <Body class="text-center">
            <span class="block font-bold">{{
              $t('health_actions.scheduler.subtitle')
            }}</span>
            <span class="block py-6">{{ schedulerCardDescription }}</span>
          </Body>
          <div class="px-80 mt-10 text-center">
            <HMButton rounded="full" @click="openSchedulerModal">
              {{ schedulerCardButtonMessage }}
            </HMButton>
          </div>
        </div>
      </div>
    </div>
    <Modal
      :active="schedulerModalOpen"
      closeOnBackDrop
      @close="closeSchedulerModal"
    >
      <SchedulerModal @close="closeSchedulerModal" />
    </Modal>
  </Card>
</template>

<script>
import { Card, CardHeader } from '@components/common/card/index'
import healthActionMixin from '@platform-shared/mixins/health-actions/healthActionMixin.js'
import SchedulerHeadsetIconSection from './SchedulerHeadsetIconSection.vue'
import SchedulerModal from './SchedulerModal'
import Modal from '@components/common/Modal'
export default {
  components: {
    Card,
    CardHeader,
    SchedulerHeadsetIconSection,
    SchedulerModal,
    Modal,
  },
  mixins: [healthActionMixin],
}
</script>
